import OSMWMSImage from 'images/flight-planning/layers/osm-wms.png';
import SRTM30ColoredImage from 'images/flight-planning/layers/srtm30-colored.png';
import SRTM30ColoredHillshadeImage from 'images/flight-planning/layers/srtm30-colored-hillshade.png';
import TopoOSMWMSImage from 'images/flight-planning/layers/topo-osm-wms.png';
import TopoWMSImage from 'images/flight-planning/layers/topo-wms.png';

import React from 'react';
import {connect} from 'react-redux';
import classNames from 'classnames';

import _ from 'topmeteo/utils/i18n';

import LayerOption from './LayerOption';

const Label = _('Layer');

const Layers = [
    {value: 'TOPO-WMS', label: _('Topo'), image: TopoWMSImage},
    {value: 'OSM-WMS', label: _('Open Street Map'), image: OSMWMSImage},
    {value: 'TOPO-OSM-WMS', label: _('Topo and OSM'), image: TopoOSMWMSImage},
    {value: 'SRTM30-Colored', label: _('Topo Light'), image: SRTM30ColoredImage},
    {value: 'SRTM30-Colored-Hillshade', label: _('Topo Radar Hillshade'), image: SRTM30ColoredHillshadeImage},
];

const LayerSelect = ({layer, colored}) => (
    <fieldset className={classNames('layer-select', {gray: colored === false})}>
        <legend>{Label}</legend>
        {Layers.map(({value, ...props}) => (
            <LayerOption
                {...props}
                key={value}
                value={value}
                checked={layer === value}
            />
        ))}
    </fieldset>
);

const mapStateToProps = ({OSMLayer, OSMColored}) => ({layer: OSMLayer, colored: OSMColored});

export default connect(mapStateToProps)(LayerSelect);
